export const STORAGE_STATE_KEY = '__APP_LOCAL_STATE__';
